<template>
  <ApplicationView>
    <DefaultLayout />
  </ApplicationView>
</template>

<script setup>
import ApplicationView from "./components/dumb/ApplicationView.vue";
import DefaultLayout from "./components/dumb/DefaultLayout.vue";
</script>
<style>
.n-dropdown-option-body {
  display: flex !important;
  align-items: center !important;
}
.n-dropdown-option-body__label {
  font-size: 12px !important;
  display: flex !important;
  align-items: center !important;
  height: 100% !important;
}
/* ── Naive date panel — global overrides (panel teleports to body) ── */
.n-date-panel {
  --n-item-color-active: #2184ff !important;
  --n-item-text-color-active: #ffffff !important;
  --n-item-color-hover: rgba(33, 132, 255, 0.12) !important;
  --n-item-text-color-hover: #2184ff !important;
}

.n-date-panel .n-date-panel-item--selected,
.n-date-panel .n-date-panel-item--selected:hover {
  background: #2184ff !important;
  color: #ffffff !important;
}

.n-date-panel .n-date-panel-item--current {
  color: #2184ff !important;
}

.n-date-panel .n-date-panel-item:not(.n-date-panel-item--disabled):hover {
  color: #2184ff !important;
}
.n-data-table {
  .n-data-table-thead {
    background-color: #f2f2f2 !important;
  }
  .n-data-table-th {
    background-color: #f2f2f2 !important;
  }
  :deep(.n-data-table .n-data-table-tr:hover) {
    background-color: #f2f2f2 !important;
  }
}
</style>
